// 公司列表展示 + 编辑弹窗（自动填充 + 更新）
import { Table, Space, Button, Modal, Form, Input, Select, message } from 'antd';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useCompanyList } from '@/hooks/useCompanyList';
import { getCompanyDetailAPI, updateCompanyAPI } from '@/apis/company';

const CompanyDisplay = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const power = useSelector(state => state.user.userInfo.power);
    const { companyList, refresh } = useCompanyList();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentCompanyId, setCurrentCompanyId] = useState(null);
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);

    const toCompanyDetail = (id) => navigate(`/CompanyDetail?id=${id}`);
    const openEditModal = (id) => { setCurrentCompanyId(id); setIsModalOpen(true); };
    const handleCancel = () => { setIsModalOpen(false); form.resetFields(); };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setSubmitting(true);
            await updateCompanyAPI({ id: currentCompanyId, ...values });
            message.success(t('Message.UpdateSuccess') || '更新成功');
            setIsModalOpen(false);
            refresh();
        } catch (e) {
            if (e?.errorFields) return; // 表单校验失败
            console.error(e);
            message.error(t('Message.UpdateFailed') || '更新失败');
        } finally { setSubmitting(false); }
    };

    useEffect(() => {
        if (!isModalOpen || currentCompanyId == null) return;
        let ignore = false;
        (async () => {
            try {
                const res = await getCompanyDetailAPI(currentCompanyId);
                const data = res.data || {};
                if (!ignore) {
                    form.setFieldsValue({
                        companyName: data.companyName || '',
                        power: data.power || ''
                    });
                }
            } catch (e) {
                console.error('获取公司数据失败', e);
                message.error(t('Message.FetchFailed') || '获取数据失败');
            }
        })();
        return () => { ignore = true; };
    }, [isModalOpen, currentCompanyId, form, t]);

    const columns = [
        { title: t('CompanyAdditionFormList.CompanyName'), dataIndex: 'companyName', key: 'companyName' },
        { title: t('CompanyAdditionFormList.CreatedAt'), dataIndex: 'createdAt', key: 'createdAt' },
        { title: t('CompanyAdditionFormList.UpdatedAt'), dataIndex: 'updatedAt', key: 'updatedAt' },
        {
            title: t('FormList.Action'),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button onClick={() => toCompanyDetail(record.id)} type="primary">{t('ButtonList.Check')}</Button>
                    <Button onClick={() => openEditModal(record.id)}>{t('ButtonList.Update')}</Button>
                    <Button style={{ display: power === 1 ? 'none' : 'inline-block' }} type="default" danger>{t('ButtonList.Delete')}</Button>
                </Space>
            )
        }
    ];

    return (
        <div>
            <Table dataSource={companyList} columns={columns} rowKey={r => r.id} pagination={false} />
            <Modal
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                destroyOnClose
                title={t('ButtonList.Update')}
                confirmLoading={submitting}
            >
                <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} style={{ marginTop: 12 }} preserve={false}>
                    <Form.Item name="companyName" label={t('CompanyAdditionFormList.CompanyName')} rules={[{ required: true, message: t('FormRules.Required') || '必填' }]}> 
                        <Input maxLength={64} />
                    </Form.Item>
                    <Form.Item name="power" label={t('CompanyAdditionFormList.Power')}>
                        <Select
                            style={{ width: 200 }}
                            options={[
                                { value: 'banned', label: 'banned' },
                                { value: 'normal', label: 'normal' }
                            ]}
                            allowClear
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default CompanyDisplay;
